import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import Cells from "components/ReactTable/Components/Cells/Cells";
import Row from "components/ReactTable/Components/Row";

export default function EditIntegrationsBody({
    integration_groups,
    prepareRow,
    onSetSelectedRow,
    onSetSelectedRows,
    defaultFunction,
    selectRow,
    rowClickCallback,
    rowDoubleClickCallback,
    showContextMenu,
    handleContextMenu,
    onDragEnd,
}) {
    /** Used to index the actual rows (and not grouping / group header rows)
     * and allow one consecutive index for all rows despite nested mapping by group and row
     */
    let dragRowIndex = 0;

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            {/* For each integration group, create a droppable area*/}
            {integration_groups &&
                integration_groups.map((group) => (
                    <Droppable
                        key={group.integration_group}
                        droppableId={group.integration_group}
                    >
                        {(provided, snapshot) => (
                            <tbody
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                            >
                                {/* Map the rows in each group */}
                                {group.rows.map((row, i) => {
                                    prepareRow(row);
                                    //  Grouped row is not draggable
                                    if (row.isGrouped) {
                                        return (
                                            <tr
                                                {...row.getRowProps()}
                                                key={row.id}
                                            >
                                                <Cells row={row} />
                                            </tr>
                                        );
                                    }
                                    return (
                                        <Draggable
                                            key={
                                                row.original.process +
                                                row.original.num_args.toString()
                                            }
                                            draggableId={row.original.process.toString()}
                                            index={dragRowIndex++}
                                        >
                                            {(provided, snapshot) => (
                                                <Row
                                                    innerRef={provided.innerRef}
                                                    provided={provided}
                                                    row={row}
                                                    onSetSelectedRow={
                                                        onSetSelectedRow
                                                    }
                                                    onSetSelectedRows={
                                                        onSetSelectedRows
                                                    }
                                                    defaultFunction={
                                                        defaultFunction
                                                    }
                                                    selectRow={selectRow}
                                                    rowClickCallback={
                                                        rowClickCallback
                                                    }
                                                    rowDoubleClickCallback={
                                                        rowDoubleClickCallback
                                                    }
                                                    showContextMenu={
                                                        showContextMenu
                                                    }
                                                    handleContextMenu={
                                                        handleContextMenu
                                                    }
                                                />
                                            )}
                                        </Draggable>
                                    );
                                })}
                                {provided.placeholder}
                            </tbody>
                        )}
                    </Droppable>
                ))}
        </DragDropContext>
    );
}
